export function saveOriginalReferrerCookie() {
	if (document.referrer.indexOf(window.location.host) < 0 && !window.modUtils.getCookie(window.modForm.opts.referrerCookieName)) {
		window.modUtils.setCookie(window.modForm.opts.referrerCookieName, document.referrer, window.modForm.opts.referrerCookieExpiration);
	}
}
